<template>
  <v-avatar :color="getColor" :size="size">{{ getInitials }}</v-avatar>
</template>

<script>
export default {
  props: {
    username: {
      type: String,
      default: '',
    },
    size: { type: Number, default: 26 },
  },
  computed: {
    getInitials() {
      return this.username
        .split(' ')
        .map(part => part[0])
        .join('');
    },
    // Generate color from hash so same user will always get same color without having to store in db
    getColor() {
      if (!this.username) return 'hsl(221, 5%, 41%)';
      // Create a hash of the string
      const stringUniqueHash = [...this.username].reduce((acc, char) => {
        // eslint-disable-next-line no-bitwise
        return char.charCodeAt(0) + ((acc << 5) - acc);
      }, 0);
      // Map the hash to the hue
      return `hsl(${stringUniqueHash % 360}, 64%, 41%)`;
    },
  },
};
</script>
